import { createContext, useContext } from "react";
import {
  BundleFormKey,
  CustomFormKey,
  DeltaFormKey,
  MetaFormKey
} from "./formKey";
import { ProgramService } from "@adfenix/types";

/**
 * Context for the current campaign template.
 * The key and template differs between platforms.
 */
type CampaignTemplateContext = {
  bundleGroupIndex: number;
  bundleIndex: number;
  templateIndex: number;
  bundleKey: BundleFormKey;
} & CampaignTemplatePlatformContext;
type CampaignTemplatePlatformContext =
  | {
      templateType: "delta";
      campaignKey: DeltaFormKey;
      campaignTemplate: ProgramService.DeltaCampaignTemplateModel;
    }
  | {
      templateType: "meta";
      campaignKey: MetaFormKey;
      campaignTemplate: ProgramService.MetaCampaignTemplateModel;
    }
  | {
      templateType: "custom";
      campaignKey: CustomFormKey;
      campaignTemplate: ProgramService.CustomCampaignTemplateModel;
    };

export const CampaignTemplateContext = createContext<CampaignTemplateContext>(
  {} as unknown as CampaignTemplateContext
);

export const useMetaTemplateContext = () => {
  const context = useContext(CampaignTemplateContext);

  if (context.templateType !== "meta") {
    throw new Error("Incorrect template type");
  }

  return context;
};

export const useDeltaTemplateContext = () => {
  const context = useContext(CampaignTemplateContext);

  if (context.templateType !== "delta") {
    throw new Error("Incorrect template type");
  }

  return context;
};

export const useCustomTemplateContext = () => {
  const context = useContext(CampaignTemplateContext);

  if (context.templateType !== "custom") {
    throw new Error("Incorrect template type");
  }

  return context;
};

export const useNonCustomTemplateContext = () => {
  const context = useContext(CampaignTemplateContext);
  if (context.templateType === "custom") {
    throw new Error("Incorrect template type");
  }

  return context;
};
